export const intervals = [
  {name: '5min', value: 5},
  {name: '10min', value: 10},
  {name: '15min', value: 15},
  {name: '30min', value: 30},
  {name: 'hour', value: 60},
  {name: '3hour', value: 180},
  {name: '6hour', value: 360},
  {name: '12hour', value: 720},
  {name: 'day', value: 1440},
  {name: '7day', value: 10080},
  {name: '14day', value: 20160},
  {name: '28day', value: 40320},
  {name: 'month', value: 43200}, // Approximate (30 days)
  {name: 'year', value: 525600} // Approximate (365 days)
]

export const calcInterval = period => {
  const start = new Date(period.start)
  const end = new Date(period.end)
  const totalMinutes = (end - start) / (1000 * 60) // Convert milliseconds to minutes
  const maxDataPoints = 300
  let intervalInMinutes = Math.ceil(totalMinutes / maxDataPoints)

  // Find the closest interval from predefined list
  return intervals.reduce((prev, curr) =>
    Math.abs(curr.value - intervalInMinutes) < Math.abs(prev.value - intervalInMinutes) ? curr : prev
  )
}
